module.exports = __webpack_public_path__ + "static/media/mac-mic-disabled.9968bac4.ico";